import React from 'react';

import {
  useAuth,
} from '../features/auth/AuthContext';

import ContactPage
  from '../features/contact/ContactPage';

import {
  FullPageLoader,
} from '../features/system/state/StatePage';


export default function ContactAccessRoute() {
  const {
    status,
  } =
    useAuth();

  if (
    status === 'loading'
  ) {
    return (
      <FullPageLoader />
    );
  }

  return (
    <ContactPage />
  );
}